// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-c29786d4]{padding:8px 20px;background-color:#fff;border-radius:3px;margin:20px 0}.footer[data-v-c29786d4],.title[data-v-c29786d4]{display:flex;align-items:center}.title[data-v-c29786d4]{color:#0f2345;font-weight:700;font-size:1.42857rem;line-height:1.28571rem}.back-btn[data-v-c29786d4]{margin-right:20px}.btn+.btn[data-v-c29786d4]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
